import type { Graph, Thing, WithContext } from 'schema-dts';

const toJsonLd = (data: WithContext<Thing> | Graph) => JSON.stringify(data).replace(/</g, '\\u003c');

type Props = { data: WithContext<Thing> | Graph };

export const JsonLd = ({ data }: Props) => <script type="application/ld+json">{toJsonLd(data)}</script>;
